import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.css'
import '../src/scss/custom.scss'
import '../src/scss/print.scss'
import { useDispatch, useSelector } from 'react-redux'
import { general } from './store/actions/generalActions'
import { getParentDetails, getParentVariables } from './api/User'
import { loginDetails } from './store/actions/loginDetails'
import { getVariables } from './store/actions/getVariables'
import ScrollToTop from './views/common-components/ScrollToTop'
const Layout = React.lazy(() => import('./layout/Layout'))

function App() {
  const language = useSelector((state) => state.language)
  const token = window.sessionStorage.getItem('token')
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(general(language))
  }, [language])
  const getLoginDetails = async () => {
    const data = await getParentDetails(language)
    dispatch(loginDetails(data))
  }
  const getVariablesData = async () => {
    const variablesData = await getParentVariables(language)
    dispatch(getVariables(variablesData))
  }
  useEffect(() => {
    if (token) {
      getLoginDetails()
      getVariablesData()
    }
  }, [token, language])

  return (
    <BrowserRouter>
      <Suspense>
        <ScrollToTop />
        <Routes>
          <Route exact path="*" name="Home Page" element={<Layout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
